import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { EnvelopeSimple, ArrowLeft } from "@phosphor-icons/react";
import { LogoMark } from "../components/Logo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password-link", { email, origin_url: window.location.origin });
      setSent(true);
      toast.success("Se l'email esiste, riceverai il link");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore invio email");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 py-10">
      <div className="w-full max-w-md">
        <button onClick={()=>nav("/login")} className="flex items-center gap-1 text-[#A3A3A3] text-sm font-bold uppercase mb-6" data-testid="back-to-login">
          <ArrowLeft size={16}/> Accedi
        </button>

        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12">
            <LogoMark size={48} />
          </div>
          <div>
            <div className="font-heading text-3xl font-black uppercase leading-none">ETA<span className="text-[#FFD600]">Build</span></div>
          </div>
        </div>

        {sent ? (
          <div data-testid="forgot-sent" className="bg-[#FFD600]/10 border-2 border-[#FFD600]/30 rounded-md p-6">
            <EnvelopeSimple size={40} weight="fill" className="text-[#FFD600] mb-3"/>
            <h2 className="font-heading text-3xl font-black uppercase tracking-tighter mb-2">Controlla l'email</h2>
            <p className="text-[#A3A3A3]">Se l'indirizzo <b className="text-white">{email}</b> è registrato, riceverai il link per impostare una nuova password. Controlla anche la cartella spam.</p>
          </div>
        ) : (
          <>
            <h1 className="font-heading text-5xl font-black uppercase tracking-tighter leading-none mb-2">Password dimenticata?</h1>
            <p className="text-[#A3A3A3] mb-8">Inserisci la tua email. Ti invieremo un link per reimpostare la password.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="text-xs text-[#A3A3A3] uppercase tracking-wider font-bold mb-2 block">Email</label>
                <input data-testid="forgot-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
                  className="w-full bg-[#1A1A1A] border-2 border-[#333] h-14 text-lg text-white rounded-md px-4 focus:border-[#FFD600] focus:outline-none" />
              </div>
              <button data-testid="forgot-submit" disabled={loading} type="submit"
                className="w-full bg-[#FFD600] text-[#0A0A0A] h-16 text-xl font-black uppercase tracking-tight rounded-md hover:bg-[#E6C200] transition disabled:opacity-50">
                {loading ? "Invio…" : "Invia link"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
